import { dew as _stringifyValidationErrorsDew } from "./stringifyValidationErrors";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.ParseError = void 0;
  const stringifyValidationErrors_1 = _stringifyValidationErrorsDew();
  class ParseError extends Error {
    constructor(errors) {
      super(errors.map(stringifyValidationErrors_1.stringifyValidationError).join("; "));
      this.errors = errors;
      Object.setPrototypeOf(this, ParseError.prototype);
    }
  }
  exports.ParseError = ParseError;
  return exports;
}